<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>宾馆基本信息</el-breadcrumb-item>
        <el-breadcrumb-item>信息编辑</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div>
        <el-form v-loading="formLoading" ref="commodityForm" :model="listParams" label-width="150px">
          <el-form-item label="所属片区：" prop="region">
            <el-select style="width: 300px" size="small" v-model="listParams.region" placeholder="请选择所属片区">
              <el-option label="对内" value="1"></el-option>
              <el-option label="对外" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="宾馆名称：">
            <el-input style="width: 300px" size="small" v-model="listParams.name" disabled> </el-input>
          </el-form-item>

          <el-form-item label="宾馆图片：">
            <div class="upload-thumbnail-img" :loading="uploading">
              <i class="el-icon-circle-plus-outline upload-icon"></i>
              <input type="file" class="hidden-upload" accept=".png,.jpg,.jpeg,.gif" @change="doUpload" id="uploadDom" />
            </div>
            <div class="wrap-thumbnail-img" v-if="listParams.pictures.length > 0">
              <div class="thumbnail-img" v-for="(item, index) in listParams.pictures" :key="index">
                <div class="combined-img">
                  <img :src="item" alt="" class="thumbnail-img-wrapped" :key="index" />
                  <div class="hover-img">
                    <i class="el-icon-circle-close-outline close-btn" @click="deleteImg(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="宾馆地址：" prop="address">
            <el-input style="width: 300px" type="textarea" :row="6" placeholder="请输入宾馆地址" v-model="listParams.address"> </el-input>
          </el-form-item>

          <el-form-item label="宾馆标注：">
            <el-amap
              v-if="listParams.longitude && listParams.latitude"
              vid="container"
              :zoom="16"
              :center="[listParams.longitude, listParams.latitude]"
            >
            </el-amap>
          </el-form-item>

          <el-form-item label="周边介绍：" prop="surroundDesc">
            <el-input style="width: 300px" type="textarea" :row="4" placeholder="请输入周边介绍" v-model="listParams.surroundDesc"> </el-input>
          </el-form-item>

          <el-form-item label="订房热线：" prop="tel">
            <el-input size="small" style="width: 300px" placeholder="请输入订房热线" v-model="listParams.tel"> </el-input>
          </el-form-item>

          <el-form-item label="联系方式：">
            <template v-if="listParams.concats.length > 0">
              <div style="display: flex" v-for="(item, index) in listParams.concats" :key="index">
                <el-input v-model="item.name" size="small" placeholder="请输入联系人：" style="width: 200px"> </el-input>
                <el-input
                  v-model="item.mobile"
                  size="small"
                  placeholder="请输入联系电话："
                  style="width: 300px; margin-left: 20px; margin-right: 20px"
                >
                </el-input>
                <el-button v-if="listParams.concats.length > 1" type="text" @click="deleteItem(index)"> 删除 </el-button>
              </div>
            </template>
            <el-button @click="addItem" size="small" type="primary" style="width: 60px"> 新 增 </el-button>
          </el-form-item>

          <el-form-item label="退房时间：" prop="checkTime">
            <el-time-select
              style="width: 300px"
              size="small"
              v-model="listParams.checkTime"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '14:00'
              }"
              placeholder="选择时间"
            >
            </el-time-select>
          </el-form-item>

          <el-form-item label="早餐：">
            <div style="display: flex">
              <el-radio style="line-height: 32px" v-model="listParams.breakfast" :label="true"> 有 </el-radio>
              <el-radio style="line-height: 32px" v-model="listParams.breakfast" :label="false"> 无 </el-radio>
              <span style="line-height: 32px; padding-left: 20px">早餐价格:</span>
              <el-input-number :disabled="!listParams.breakfast" size="small" class="mgl20" v-model="listParams.breakfastPrice" :min="0">
              </el-input-number>
            </div>
          </el-form-item>

          <el-form-item label="配套设施：">
            <el-checkbox :indeterminate="isIndeterminate1" v-model="checkFacilitiesAll" @change="handleCheckAllFacilitiesChange"> 全选 </el-checkbox>
            <div style="margin: 15px 0"></div>
            <el-checkbox-group v-model="listParams.facilities" @change="handleCheckedFacilitiesChange">
              <el-checkbox v-for="item in facilitiesList" :label="item" :key="item">
                {{ item }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="其他服务：">
            <el-checkbox :indeterminate="isIndeterminate2" v-model="checkServicesAll" @change="handleCheckAllServicesChange"> 全选 </el-checkbox>
            <div style="margin: 15px 0"></div>
            <el-checkbox-group v-model="listParams.services" @change="handleCheckedServicesChange">
              <el-checkbox v-for="item in servicesList" :label="item" :key="item">
                {{ item }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item class="align-center" style="padding-bottom: 20px; margin-top: 30px">
            <el-button :disabled="isDisabled" size="small" type="primary" v-on:click="saveAdd"> 保存 </el-button>
            <el-button size="small" @click="backToList">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";

VueAMap.initAMapApiLoader({
  // 高德的key
  key: "fd19e1d1e35f6c3a412043be49f9c269",
  // 插件集合
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: "1.4.4"
});

export default {
  data() {
    return {
      formLoading: false,
      listParams: {
        region: "1",
        pictures: [],
        tel: "",
        concats: [
          {
            name: "",
            mobile: ""
          }
        ],
        longitude: "",
        latitude: "",
        surroundDesc: "",
        checkTime: "",
        breakfast: true,
        breakfastPrice: "",
        address: "",
        facilities: [],
        services: []
      },
      facilitiesList: [],
      servicesList: [],
      isDisabled: false,
      uploading: false,
      method: "",
      checkFacilitiesAll: false, // 是否全选配套设施
      checkServicesAll: false, // 是否全选其他服务
      isIndeterminate1: true,
      isIndeterminate2: true
    };
  },
  mounted() {
    this.loadFacilitiesList();
    this.loadServicesList();
    this.loadDetailPage(this.$route.query.id);
  },
  methods: {
    loadFacilitiesList() {
      this.$http({
        url: global.apiUrl + "/reception/hotel/supportingFacilities/list",
        method: "GET"
      }).then((res) => {
        if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
          this.facilitiesList = res.body.data;
        }
      });
    },
    loadServicesList() {
      this.$http({
        url: global.apiUrl + "/reception/hotel/services/list",
        method: "GET"
      }).then((res) => {
        if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
          this.servicesList = res.body.data;
        }
      });
    },
    saveAdd: function () {
      this.isDisabled = true;
      const bodyParams = Object.assign({}, this.listParams);
      this.$http({
        url: global.apiUrl + "/reception/hotel/edit",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        emulateJSON: false,
        body: bodyParams
      })
        .then((res) => {
          this.isDisabled = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.$message.success(res.body.info);
            this.$router.push({
              name: "roomInfo"
            });
          } else {

            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.isDisabled = false;
          this.tableLoading = false;

          console.error(err);
        });
    },
    loadDetailPage(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/reception/hotel/detail?hotelId=" + id,
        method: "GET"
      })
        .then((res) => {
          this.formLoading = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data.hotel;
              Object.assign(this.listParams, data);
            }
          }
        })
        .catch((err) => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 上传图片
     */
    doUpload() {
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const file = files[0];
      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/good-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then((res) => {
          this.uploading = false;
          this.listParams.pictures.push(res.data.data);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除图片
     * @param index
     */
    deleteImg(index) {
      this.listParams.pictures.splice(index, 1);
    },
    /**
     * 限购规则的change事件
     * @param val
     */
    changeSupplyRuleIds(val) {
      this.supplyRuleIds = val;
    },

    /**
     * 返回列表页
     */
    backToList() {
      this.$router.push({
        name: "roomInfo"
      });
    },
    /**
     * 新增联系方式
     */
    addItem() {
      this.listParams.concats.push({
        name: "",
        mobile: ""
      });
    },
    /**
     * 删除联系方式
     * @param index
     */
    deleteItem(index) {
      this.listParams.concats.splice(index, 1);
    },
    /**
     * 全选配套设施
     * @param val
     */
    handleCheckAllFacilitiesChange(val) {
      this.listParams.facilities = val ? this.facilitiesList : [];
      this.isIndeterminate1 = false;
    },
    /**
     * 配套设施change事件
     * @param value
     */
    handleCheckedFacilitiesChange(value) {
      const checkedCount = value.length;
      this.checkFacilitiesAll = checkedCount === this.facilitiesList.length;
      this.isIndeterminate1 = checkedCount > 0 && checkedCount < this.facilitiesList.length;
    },
    /**
     * 全选其他服务
     * @param val
     */
    handleCheckAllServicesChange(val) {
      this.listParams.services = val ? this.servicesList : [];
      this.isIndeterminate2 = false;
    },
    /**
     * 其他服务change事件
     * @param value
     */
    handleCheckedServicesChange(value) {
      const checkedCount = value.length;
      this.checkServicesAll = checkedCount === this.servicesList.length;
      this.isIndeterminate2 = checkedCount > 0 && checkedCount < this.servicesList.length;
    }
  },
  watch: {
    "listParams.breakfast": function (val, oldVal) {
      if (!val) {
        this.listParams.breakfastPrice = 0;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.hx-form-container {
  .wang-editor-style {
    height: 600px;

    .wang-editor-body {
      height: 540px;
    }
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
  #container {
    width: 80%;
    height: 500px;
  }
}
</style>
